import { render } from "./LoadInfo.vue?vue&type=template&id=2e64a078&scoped=true"
import script from "./LoadInfo.vue?vue&type=script&lang=js"
export * from "./LoadInfo.vue?vue&type=script&lang=js"

import "./LoadInfo.vue?vue&type=style&index=0&id=2e64a078&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e64a078"]])

export default __exports__